export const applicationPaths = {
  sites: {
    getPrvAutocomplete: 'sites/prv/search',
    getCpAutocomplete: 'sites/cp/search',
    getSitePressureChannels: ({ id }: { id: number }) => `sites/${id}/channels/pressure`,
    getSiteChannels: ({ id }: { id: number }) => `sites/${id}/channels`,
    getSite: ({ id }: { id: string }) => `sites/${id}`,
    stats: 'sites/statistics',
    statsPRV: 'sites/statistics/prv',
    statsCP: 'sites/statistics/cp',
    getSiteBoundaryForAccount: 'sites/map/account/boundary',
    getSitesOnMap: 'sites/map',
    getPMZoneSites: 'sites',
    siteAlarms: ({ id }: { id: number }) => `sites/${id}/alarms`,
    siteAlarmsCsv: ({ id }: { id: number }) => `sites/${id}/alarms/csv`,
    photo: ({ siteId, photoId }: { siteId: string; photoId?: string }) => `sites/${siteId}/photo/${photoId ?? ''}`,
    photos: ({ siteId }: { siteId: string }) => `sites/${siteId}/photo`,
    csq: 'sites/csq',
    additionalSignals: 'sites/additionalSignals',
    getBatteryGraph: 'sites/batteryLevel',
    acknowledge: ({ siteId, alarmId }: { siteId: number; alarmId: number }) =>
      `sites/${siteId}/alarms/${alarmId}/acknowledge`,
    getActuations: 'sites/actuations',
    clusters: 'sites/clusters',
    getPegasusTables: ({ id }: { id: number }) => `sites/${id}/pegasusdetails`,
    predefinedPegasusTables: ({ siteId }: { siteId: number }) => `sites/${siteId}/predefinedPegasusDetails`,
    predefinedPegasusFlowTables: ({ siteId, tableId }: { siteId: number; tableId?: number }) =>
      `sites/${siteId}/predefinedPegasusDetails/flow${tableId ? `/${tableId}` : ''}`,
    predefinedPegasusTimeTables: ({ siteId, tableId }: { siteId: number; tableId?: number }) =>
      `sites/${siteId}/predefinedPegasusDetails/time${tableId ? `/${tableId}` : ''}`,
  },
  accounts: {
    mainAccount: 'accounts/profile',
    subAccounts: ({ accountId }: { accountId: string }) => `accounts/${accountId}/subaccounts`,
    getAccAutocomplete: 'accounts/search',
    getAccountById: ({ accountId }: { accountId: string }) => `accounts/${accountId}`,
    accountAlarms: ({ id }: { id: number }) => `accounts/${id}/alarms`,
    accountAlarmsCsv: ({ id }: { id: number }) => `accounts/${id}/alarms/csv`,
    permissions: 'accounts/profile/permissions',
    defaultUnits: 'accounts/defaultUnits',
    getActuationsReport: ({ accountId }: { accountId: string }) => `accounts/${accountId}/actuations/csv`,
  },
  pmZones: {
    addPMZone: 'pmzones',
    addSiteToPMZone: ({ accountId }: { accountId: number }) => `pmzones/${accountId}/site`,
    removeSiteFromPMZone: ({ accountId, siteId }: { accountId: number; siteId: number }) =>
      `pmzones/${accountId}/site/${siteId}`,
    editPMZone: ({ id }: { id: number }) => `pmzones/${id}`,
    getPMZone: ({ id }: { id: number }) => `pmzones/${id}`,
    removePMZone: ({ id }: { id: number }) => `pmzones/${id}`,
    getUpdateInformation: ({ id }: { id: number }) => `pmzones/${id}/updateInformation`,
    callInSettings: ({ id }: { id: number }) => `pmzones/${id}/callInSettings`,
    getModeSettings: ({ accId, prvId }: { accId: number; prvId: number }) =>
      `pmzones/${accId}/modeSettings/prv/${prvId}`,
    putModeSettings: ({ accId }: { accId: number }) => `pmzones/${accId}/modeSettings`,
    recalculate: ({ id }: { id: number }) => `pmzones/${id}/modeSettings/recalculate`,
    getMainGraphData: ({ id }: { id: number }) => `pmzones/${id}/deviceData`,
    exportFormats: 'pmzones/graph/export/formats',
    exportData: ({ id }: { id: number }) => `pmzones/${id}/graph/export`,
    fleetReport: ({ id }: { id: number }) => `pmzones/${id}/fleetReport`,
    maintenanceReport: ({ id }: { id: number }) => `pmzones/${id}/maintenanceFleetReport`,
  },
  audits: {
    getLogs: 'audits',
  },
  users: {
    root: 'users',
    getAccessProfile: ({ id }: { id: number }) => `${applicationPaths.users.root}/${id}/accessProfile`,
  },
  translations: {
    translations: 'translations',
    live: (languageCode: string) => `${applicationPaths.translations.translations}/live/${languageCode}`,
  },
  featureFlags: {
    features: `features/account`,
  },
  preferences: {
    preferences: 'Preferences',
  },
};
